module.exports = __webpack_public_path__ + "1ab58fb05886a9347b29c8d742f3d33b.html";


//////////////////
// WEBPACK FOOTER
// ./src/portal/components/sp-company-user-label/sp-company-user-label.html
// module id = 1097
// module chunks = 0